import { IoBriefcaseOutline, IoCallOutline, IoMailOutline } from 'react-icons/io5';

import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { CompanyProfile, CompanyService } from 'models';

import { Avatar } from 'components/avatar/Avatar';
import { ProfileRow, ProfileRowCarousel } from 'components/company-profile/components/ProfileRow';
import { Section, SectionProps } from 'components/section/Section';

const ContactPeople = ({
    contacts,
    company,
    titleSection,
    ...props
}: {
    contacts: CompanyProfile['contactPeople'];
    company: CompanyProfile;
} & SectionProps) => {
    if (!contacts.length) {
        return null;
    }

    // With in-app support, people reach the team through Send Message instead of direct details
    const showDirectContact = !company.services?.includes(CompanyService.IN_APP_SUPPORT);

    return (
        <Section title="Team" id="team" {...props}>
            <ProfileRowCarousel dense>
                {contacts.map((person, index) => (
                    <ProfileRow
                        key={index}
                        size="lg"
                        leading={<Avatar size={72} name={person.name} image={CollectionHelpers.id(person.image)} />}
                        title={person.name}
                        meta={person.position}
                        metaIcon={<IoBriefcaseOutline />}
                        details={showDirectContact && (person.email || person.phone)}
                        detailsIcon={person.email ? <IoMailOutline /> : <IoCallOutline />}
                        href={showDirectContact && person.email ? `mailto:${person.email}` : undefined}
                    />
                ))}
            </ProfileRowCarousel>
        </Section>
    );
};

export { ContactPeople };
